import { render, staticRenderFns } from "./PilotLadderDeclaration.vue?vue&type=template&id=04fd48a1&scoped=true&"
import script from "./PilotLadderDeclaration.vue?vue&type=script&lang=js&"
export * from "./PilotLadderDeclaration.vue?vue&type=script&lang=js&"
import style0 from "./PilotLadderDeclaration.vue?vue&type=style&index=0&id=04fd48a1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04fd48a1",
  null
  
)

export default component.exports